module.exports = __webpack_public_path__ + "img/css-framework1.e6d05081.png";